<template>
    <img :src="'/logo.jpg'" alt="logo">
</template>
